<template>
  <div id="app">
    <commonhead :active_menu="2" :show_type="2" :bg="bg" />
    <div class="search_teacher my_style search_teacher_style">
      <div class="banner">
        <img src="../../assets/image/search_teacher/banner.png" class="pic_full" />
      </div>
      <div class="search_teacher_filter">
        <div class="content_wrap">
          <span class="item_head">条件查找</span>
          <div class="sexbox">
            <span class="sex">性别:</span>
            <Select v-model="sex" placeholder="全部" class="sex_choose">
              <Option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></Option>
            </Select>
          </div>

          <div class="divider"></div>
          <div class="datebox" @click="timeShow">
            <input type="text" class="datetime" placeholder="可上课时间" readonly v-model="datetime">
            <div class="icon-time"></div>
          </div>
          <!-- <DatePicker
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:302px"
            value-format="yyyy-MM-dd"
          ></DatePicker>
          <div class="divider"></div>
          <TimePicker
            is-range
            v-model="time"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            style="width:302px"
            value-format="HH:mm:ss"
          ></TimePicker> -->
          <div class="search_name_area">
            <span class="item_head">姓名查找</span>
            <span class="dib pr">
              <input v-model="name" placeholder="请输入外教名字" class="search_name" />
              <span class="search_icon hand_point" @click="search">
                <img src="../../assets/image/search_teacher/icon (4).png" class="pic_full" />
              </span>
            </span>
          </div>
        </div>
      </div>

      <!--老师列表-->
      <div :class="free_course > 0 ? 'teacher_list':'teacher_list dif'">
        <div class="free_notice" v-if="free_course > 0">
         您有<span class="dif">{{free_course}}</span>节免费体验课，赶快预约吧!
       </div>
        <div class="content">
          <div v-if="teacherData.total > 0">
            <div
              class="item pr hand_point"
              v-for="(item,index) of teacherData.list"
              :key="index"
              @click="$router.push(`./teacher-details?id=${item.id}&is_fulltime=${item.is_fulltime}`)"
            >
              <span class="pic">
                <img :src="item.avatar" class="pic_full" v-if="item.avatar" />
                <div class="avatar_default pic_full" v-if="!item.avatar"></div>
                <!-- <span class="tag">智能推荐</span> -->
              </span>
              <div class="info">
                <p class="name">{{item.real_name}}</p>
                <div class="teacher_infos">
                  <div class="teacher_info">
                    <div class="icon-sex"></div>
                    <div class="info-box">
                      <div class="info-text">性别</div>
                      <div class="info-value">{{item.gender == 0 ? '女':'男'}}</div>
                    </div>
                  </div>
                  <div class="teacher_info">
                    <div class="icon-year"></div>
                    <div class="info-box">
                      <div class="info-text">教学经验</div>
                      <div class="info-value">{{item.years}}年</div>
                    </div>
                  </div>
                  <div class="teacher_info">
                    <div class="icon-course"></div>
                    <div class="info-box">
                      <div class="info-text">课时</div>
                      <div class="info-value">{{item.is_fulltime}}</div>
                    </div>
                  </div>
                </div>
                <div class="teacher-tagbox">
                  <div class="icon-tag"></div>
                  <div class="teacher-tags">
                    <div class="teacher-tagtext">标签</div>
                    <div class="teacher-tagvalue">
                      <span v-for="(itemIn,index) in JSON.parse(item.labels)" :key="index">
                        {{itemIn}}
                        <span v-if="index < JSON.parse(item.labels).length-1">、</span>
                      </span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="right_area pr">
                <div class="score">
                  <p class="cost">
                    <span class="num">{{item.price}}</span>
                    学贝（{{item.price}}人民币）
                  </p>
                  <div class="star">
                    <span class="icon" v-if="item.score >= 1">
                      <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
                    </span>
                    <span class="icon" v-if="item.score >= 2">
                      <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
                    </span>
                    <span class="icon" v-if="item.score >= 3">
                      <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
                    </span>
                    <span class="icon" v-if="item.score >= 4">
                      <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
                    </span>
                    <span class="icon" v-if="item.score >= 5">
                      <img src="../../assets/image/search_teacher/new/icon-star.png" alt class="pic_full" />
                    </span>
                  </div>
                  <button class="month_point" @click.stop="monthShow(item)">每周固定预约</button>
                  <button
                    :class="(free_course != 0 && item.has_free == '1') ? 'apply_now hand_point free':'apply_now hand_point'"
                    @click.stop="show_cal(0,item)"
                  >{{(free_course != 0 && item.has_free == '1') ? '免费预约':'立即预约'}}</button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="no_data"
            style="text-align: center;padding-bottom: 60px;"
            v-if="!(teacherData.total)"
          >没有找到数据</div>
          <!--分页器-->
          <div class="pagination" v-if="teacherData.total > 0">
            <Pagination
              background
              layout="prev, pager, next"
              :total="teacherData.total"
              @current-change="getList"
            ></Pagination>
          </div>
        </div>
      </div>
      <div class="choose_time" v-if="bg_model_copy" v-show="bg_model" id="bg" ref="calendar">
        <div class="content">
          <p class="title">
            请选择预约时间
            <i class="fr el-icon-close hand_point" @click="show_cal(1)"></i>
          </p>
          <div class="table">
            <FullCalendar
              :events="events"
              :config="config"
              class="fc"
              locale="fr"
              @event-selected="eventDrop"
            ></FullCalendar>
          </div>
          <div class="btns">
            <Button type="danger" @click="show_cal(1)">取消</Button>
            <Button type="success" @click="first_submit">提交</Button>
          </div>
        </div>
      </div>
      <div class="choose_time" v-show="confirm_model" id="bg">
        <div class="content_choose">
          <p class="title">
            请确认选课
            <i class="fr el-icon-close hand_point" @click="show_confirm(1)"></i>
          </p>
          <div class="info">
            <p class="title">当前已选择课程时间，请先确认</p>
            <div class="item" v-for="(item,index) in choose_course" :key="index">{{index+1}}. 上课时间：{{item.time}}</div>
            <!-- <p class="title" style="margin-top:30px;margin-bottom:10px">请选择一种上课方式</p>
            <Radio v-model="radio" label="1">鲸贝在线教室</Radio> -->
          </div>
          <div class="btns">
            <Button type="danger" @click="show_confirm(1)">取消</Button>
            <Button type="success" :loading="loading" :disabled="loading" @click="fin_submit">下单</Button>
          </div>
        </div>
      </div>
      <!--底部信息-->
      <div class="bottombox">
        <commonbottom />
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
      <!-- 选择时间 -->
      <div class="time_modal common-modal" v-if="timemodal">
        <div class="modal-content">
          <div class="icon-close" @click="timeClose"></div>
          <div class="modal-title">选择时间</div>
          <div class="time_items">
            <div class="time_item" v-for="(time,index) in timeArr" :key="index" :class="time.active?'time_item_active':''" @click="timeSelect(index)">
              <div class="icon-common" :class="'icon_'+(index+1)"></div>
              <div class="time_text">{{time.text}}</div>
              <div class="time_value">{{time.value}}</div>
            </div>
          </div>
          <div class="day_items">
            <div class="day_item" :class="dayitem.active?'day_item_active':''" v-for="(dayitem,index) in dayArr" :key="index" @click="daySelect(index)">{{dayitem.text}}</div>
          </div>
          <div class="modal-actions">
            <div class="btn_action btn_action_cancel" @click="timeClose">取消</div>
            <div class="btn_action btn_action_confirm" @click="timeConfirm">确定</div>
          </div>
        </div>
      </div>
      <!-- 固定预约 -->
      <div class="monthtime_modal common-modal" v-if="monthtimemodal">
        <div class="modal-content">
          <div class="icon-close" @click="monthClose"></div>
          <div class="modal-title">申请和{{currentTeacher && currentTeacher.real_name}}老师每周固定上课</div>
          <div class="day_title">请选择星期几？</div>
          <div class="day_items">
            <div class="day_item" v-for="(monthday,index) in monthdayArr" :key="index" :class="monthday.active?'day_item_active':''" @click="monthtimeSelect(index)">
              <div class="icon-common"></div>
              <div class="day_text">{{monthday.text}}</div>
            </div>
          </div>
          <div class="time_title">请选择时间段？</div>
          <div class="time_items">
            <div class="time_item" :class="monthtime.active?'time_item_active':''" v-for="(monthtime,index) in monthtimeArr" :key="index" @click="monthdaySelect(index)">
              <div class="icon-select"></div>
              <div class="time_text">{{monthtime.text}}（{{monthtime.value}}）</div>
            </div>
          </div>
          <div class="timedetail_title">
            请选择详细时间？
          </div>
          <div class="timedetails">
            <div class="timedetail_item">
              <div class="time_notice">*</div>
              <Select v-model="time_selected" placeholder="请选择" class="time_choose" v-if="monthtimeArr[0].active">
                <Option v-for="item in timemorning" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
              <Select v-model="time_selected" placeholder="请选择" class="time_choose" v-if="monthtimeArr[1].active">
                <Option v-for="item in timenoon" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
              <Select v-model="time_selected" placeholder="请选择" class="time_choose" v-if="monthtimeArr[2].active">
                <Option v-for="item in timenight" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
            </div>
            <!-- <div class="timedetail_item">
              <div class="time_notice"></div>
              <Select v-model="sex" placeholder="请选择" class="time_choose">
                <Option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></Option>
              </Select>
              <div class="timedetail_tip">（需要每次上两次课的选择此项）</div>
            </div> -->
          </div>
          <div class="monthtime_info">本次请求与老师协商通过后，老师的该时间将一直为您保留，如果需要中止，请联系您的助教处理。</div>
          <div class="modal-actions">
            <div class="btn_action btn_action_cancel" @click="monthClose">取消</div>
            <div class="btn_action btn_action_confirm" @click="monthConfirm">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from "../common/common_bottom";
import { DatePicker, TimePicker, Select, Option, Pagination,Radio,Button } from "element-ui";
import { FullCalendar } from "vue-full-calendar";
import moment from "moment";
import "fullcalendar/dist/fullcalendar.css";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    DatePicker,
    TimePicker,
    Select,
    Option,
    Pagination,
    commonbottom,
    Radio,
    FullCalendar,
    Button
  },
  data: function() {
    return {
      date: "",
      time: "",
      datetime: '',
      options: [
        {
          value: "全部",
          label: "全部"
        },
        {
          value: "男",
          label: "男"
        },
        {
          value: "女",
          label: "女"
        }
      ],
      sex: "",
      name: "",
      teacherData: "",
      bg: "",
      free_course: "",
      free_notice: 0,
      timemodal: false,
      monthtimemodal: false,
      timeArr: [
        {
          text: '上午',
          value: '9-12',
          active: false,
          index: 1,
        },
        {
          text: '下午',
          value: '14-17',
          active: false,
          index: 2
        },
        {
          text: '晚上',
          value: '19-22',
          active: false,
          index: 3
        }
      ],
      dayArr: [
        {
          text: '周一',
          value: '1',
          active: false
        },
        {
          text: '周二',
          value: '2',
          active: false
        },
        {
          text: '周三',
          value: '3',
          active: false
        },
        {
          text: '周四',
          value: '4',
          active: false
        },
        {
          text: '周五',
          value: '5',
          active: false
        },
        {
          text: '周六',
          value: '6',
          active: false
        },
        {
          text: '周日',
          value: '0',
          active: false
        }
      ],
      monthdayArr:[
        {
          text: '星期一',
          value: '1',
          active: false
        },
        {
          text: '星期二',
          value: '2',
          active: false
        },
        {
          text: '星期三',
          value: '3',
          active: false
        },
        {
          text: '星期四',
          value: '4',
          active: false
        },
        {
          text: '星期五',
          value: '5',
          active: false
        },
        {
          text: '星期六',
          value: '6',
          active: false
        },
        {
          text: '星期日',
          value: '0',
          active: false
        }
      ],
      monthtimeArr: [
        {
          text: '上午',
          value: '8:00-12:00',
          active: true
        },
        {
          text: '下午',
          value: '12:00-18:00',
          active: false
        },
        {
          text: '晚上',
          value: '18:00-22:00',
          active: false
        }
      ],
      bg_model: false,
      confirm_model: false,
      courseData: "",
      radio: "1",
      is_show: false,
      bg_model_copy: false,
      events: [],
      choose_course: [],
      config: {
        firstDay: 1,
        locale: "zh-cn",
        defaultView: "agendaWeek",

        height: "auto",
        header: {
          left: "title",
          center: "",
          right: "prev,today,next"
        },
        /* agenda 模式 */
        allDaySlot: false,
        slotLabelFormat: "H:mm", // axisFormat 'H(:mm)'
        slotLabelInterval: 1,
        slotDuration: "00:30:00",
        minTime: "0:00",
        maxTime: "24:00",
        editable: false,
        selectable: false,
        loading: false,
        /* 设置按钮文字 */
        buttonText: {
          today: "今天"
        }
      },
      currentTeacher: null,
      timemorning: [
        {
          value: '08:00-08:25'
        },
        {
          value: '08:30-08:55'
        },
        {
          value: '09:00-09:25'
        },
        {
          value: '09:30-09:55'
        },
        {
          value: '10:00-10:25'
        },
        {
          value: '10:30-10:55'
        },
        {
          value: '11:00-11:25'
        },
        {
          value: '11:30-11:55'
        },
      ],
      timenoon: [
        {
          value: '12:00-12:25'
        },
        {
          value: '12:30-12:55'
        },
        {
          value: '13:00-13:25'
        },
        {
          value: '13:30-13:55'
        },
        {
          value: '14:00-14:25'
        },
        {
          value: '14:30-14:55'
        },
        {
          value: '15:00-15:25'
        },
        {
          value: '15:30-15:55'
        },
        {
          value: '16:00-16:25'
        },
        {
          value: '16:30-16:55'
        },
        {
          value: '17:00-17:25'
        },
        {
          value: '17:30-17:55'
        }
      ],
      timenight: [
        {
          value: '18:00-18:25'
        },
        {
          value: '18:30-18:55'
        },
        {
          value: '19:00-19:25'
        },
        {
          value: '19:30-19:55'
        },
        {
          value: '20:00-20:25'
        },
        {
          value: '20:30-20:55'
        },
        {
          value: '21:00-21:25'
        },
        {
          value: '21:30-21:55'
        },
      ],
      time_selected: '',
      dayindex: 0,
      loading: false
    };
  },
  mounted: function() {
    this.getList();
    this.getInfo();
  },
  methods: {
    getList(
      page,
      gender,
      date,
      time,
      real_name
    ) {
      //获取老师列表
      let self = this;
      common.requestFun(
        self,
        "get",
        "/teacher/list",
        {
          page: page,
          pagesize: 10,
          lang: "",
          gender: gender,
          date: date,
          time: time,
          real_name: real_name
        },
        res => {
          if (res.data.code == 200) {
            self.teacherData = res.data.data;
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
    },
    search() {
      //搜索
      this.getList(
        1,
        this.sex == "男" ? 1 : 0,
        this.date,
        this.time,
        this.name
      );
    },
    register() {
      this.bg = Math.random();
    },
    getInfo() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          self.free_course = res.data.data.free_course;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
          self.$router.push("./");
        }
      });
    },
    timeSelect(index){
      this.timeArr[index].active = !this.timeArr[index].active;
    },
    daySelect(index){
      this.dayArr[index].active=!this.dayArr[index].active;
    },
    timeClose(){
      this.timemodal = false;
    },
    monthtimeSelect(index){
      this.monthdayArr[index].active = !this.monthdayArr[index].active;
    },
    monthdaySelect(index){
      if(this.dayindex==index){
        return;
      }else{
        this.time_selected = '';
      }
      this.monthtimeArr[this.dayindex].active = false;
      this.dayindex = index;
      this.monthtimeArr[index].active = true;
    },
    timeConfirm(){
      this.time='';
      this.date='';
      this.datetime='';
      var timeArr = this.timeArr.filter(item=>item.active);
      var dayArr = this.dayArr.filter(item=>item.active);
      if(timeArr.length==0&&dayArr.length==0){
        // this.timeClose();
      }else{
        timeArr.forEach((item,index)=>{
            this.time+=(index!=0?',':'')+item.index;
        })
        dayArr.forEach((item,index)=>{
            this.date+=(index!=0?',':'')+item.value;
        })
        if(dayArr.length==0){
          timeArr.forEach((item,index)=>{
            if(timeArr.length==3){
              this.datetime='上午-下午+1';
            }else{
              this.datetime+=(index!=0?'-':'')+item.text;
            }
          })
        }else{
          if(timeArr.length==0){
            if(dayArr.length>=3){
              this.datetime = dayArr[0].text+'-'+dayArr[0].text+'+'(dayArr.length-2);
            }else{
              dayArr.forEach((item,index)=>{
                this.datetime+=(index!=0?'-':'')+item.text;
              })
            }
          }else{
            this.datetime = timeArr[0].text + '-' + dayArr[0].text + ((timeArr.length+dayArr.length)>=3?('+'+(timeArr.length+dayArr.length-2)):'')
          }
        }
        this.timeClose();
      }
    },
    monthConfirm(){
      let self = this;
      var dayArr = this.monthdayArr.filter(item=>item.active);
      if(dayArr.length==0){
        this.$message({
          message: "请选择星期几",
          type: "error",
          center: true
        });
        return;
      }
      if(!this.time_selected){
        this.$message({
          message: "请选择详细时间",
          type: "error",
          center: true
        });
        return;
      }
      let weekdays = [];
      dayArr.forEach(item => {
        weekdays.push(item.value);
      });
      common.requestFun(
          self,
          "post",
          "/reservation/plan/apply",
          {
            time_range: self.dayindex+1,
            weekdays: weekdays,
            teacher_id: self.currentTeacher.id,
            specific_time: self.time_selected
          },
          res => {
            if (res.data.code == 200||res.data.code=='ok') {
              self.$message({
                message: res.data.msg,
                type: "success",
                center: true
              });
              self.monthClose()
              self.$router.push('/user/course');
            } else {
              if (res.data.msg) {
                self.$message({
                  message: res.data.code == 401 ? "请登录" : res.data.msg,
                  type: "error",
                  center: true
                });
              }
            }
          }
        );
    },
    timeShow(){
      this.timemodal = true;
    },
    monthShow(teacher){
      this.currentTeacher = teacher;
      this.monthtimemodal = true;
    },
    monthClose(){
      this.monthtimemodal = false;
    },
    eventDrop(e) {
      if (e.backgroundColor == "red") {
        this.$message({
          message: "不能选择该课程",
          type: "error",
          center: true
        });
        return false;
      }
      for (let item of this.events) {
        if (item.id == e.id) {
          item.borderColor = item.borderColor == "yellow" ? "green" : "yellow";
        }
      }
    },
    first_submit() {
      for (let item of this.events) {
        if (item.borderColor == "yellow") {
          this.choose_course.push({
            id: item.id,
            time: item.start
          });
        }
      }
      if (this.choose_course.length == 0) {
        this.$message({
          message: "您还没有选择课程",
          type: "error",
          center: true
        });
        return;
      }
      this.confirm_model = true;
    },
    fin_submit() {
      //预约操作
      let self = this;
      self.loading = true
      let course_id = [];
      for (let item of this.choose_course) {
        course_id.push(item.id);
      }
      if (this.free_course != 0 && this.currentTeacher.has_free == "1") {
        if (course_id.length > 1) {
          self.$message({
            message: "免费体验课一次只能预约一节",
            type: "error",
            center: true
          });
          self.loading = false
          return;
        }
        common.requestFun(
          //免费预约体验课
          self,
          "post",
          "/reservation/exp/create",
          {
            class_tool: 1,
            course_id: course_id[0],
            teacher_id: self.currentTeacher.id
          },
          res => {
            if (res.data.code == 200) {
              self.$message({
                message: res.data.msg,
                type: "success",
                center: true
              });
              self.choose_course = [];
              self.bg_model = false;
              self.confirm_model = false;
              self.$router.push("/user/course");
            } else {
              if (res.data.msg) {
                self.$message({
                  message: res.data.code == 401 ? "请登录" : res.data.msg,
                  type: "error",
                  center: true
                });
              }
            }
            self.loading = false
          }
        );
      } else {
        common.requestFun(
          self,
          "post",
          "/reservation/creates",
          {
            class_tool: 1,
            course_id: course_id,
            teacher_id: self.currentTeacher.id
          },
          res => {
            if (res.data.code == 200) {
              self.$message({
                message: res.data.msg,
                type: "success",
                center: true
              });
              self.choose_course = [];
              self.bg_model = false;
              self.confirm_model = false;
              self.$router.push(
                "./user-order-details?order_id=" + res.data.data.order_id
              );
            } else {
              if (res.data.msg) {
                self.$message({
                  message: res.data.code == 401 ? "请登录" : res.data.msg,
                  type: "error",
                  center: true
                });
              }
            }
            self.loading = false
          }
        );
      }
    },
    getLocalTime(now) {
      var year = now.getFullYear(); //取得4位数的年份
      var month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
      var date = now.getDate(); //返回日期月份中的天数（1到31）
      var hour = now.getHours(); //返回日期中的小时数（0到23）
      var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
      var second = now.getSeconds(); //返回日期中的秒数（0到59）
      if (minute == 29) {
        minute = 30;
      }
      return (
        year +
        "-" +
        (month < 10 ? "0" + month.toString() : month.toString()) +
        "-" +
        (date < 10 ? "0" + date.toString() : date.toString()) +
        " " +
        (hour < 10 ? "0" + hour.toString() : hour.toString()) +
        ":" +
        (minute < 10 ? "0" + minute.toString() : minute.toString())
      );
    },
    show_cal(type,teacher) {
      let self = this;
      if(teacher){
        this.currentTeacher = teacher;
      }
      this.events = [];
      if(type == 0){
        self.bg_model = true;
        // 先获取老师的课程表
        common.requestFun(
        self,
        "get",
        "/teacher/course/available",
        {
          teacher_id: self.currentTeacher.id
        },
        res => {
          if (res.data.code == 200) {
            //全职老师提前1小时能约课，兼职老师提前12小时能约课
            let more_time =
              self.currentTeacher.is_fulltime == 1 ? 1800 : 1 * 1800;
            for (let item of res.data.data) {
              self.events.push({
                borderColor:
                  (item.start - more_time <
                    Math.round(new Date().getTime() / 1000).toString() ||
                  item.status == 2)
                    ? "red"
                    : "green",
                start: self.getLocalTime(new Date(parseInt(item.start) * 1000)),
                end: self.getLocalTime(new Date(parseInt(item.end) * 1000)),
                id: item.id,
                backgroundColor:
                  (item.start - more_time <
                    Math.round(new Date().getTime() / 1000).toString() ||
                  item.status == 2)
                    ? "red"
                    : "green"
              });
            }
            self.bg_model = type == 0 ? true : false;
            if (type == 0 && !self.is_show) {
              self.is_show = true;
              self.bg_model_copy = true;
            }
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true
              });
            }
          }
        }
      );
      }else{
        this.bg_model = type == 0 ? true : false;
        if (type == 0 && !this.is_show) {
          this.is_show = true;
          this.bg_model_copy = true;
        }
      }

    },
    show_confirm(type) {
      if (type == 1) {
        this.choose_course = [];
      }
      this.confirm_model = type == 0 ? true : false;
    },
  }
};
</script>
<style scoped src="./search_teacher.css"></style>
